import PlatformModel from 'Models/PlatformModel';
import { buildSeoModelByGame } from 'Models/SeoModel';

const GAMES_AS_TAGS_MAP = process.env.GAMES_AS_TAGS_MAP
  ? JSON.parse(process.env.GAMES_AS_TAGS_MAP)
  : {};

const GameModel = {};

// eslint-disable-next-line no-nested-ternary
let gamesArgument = typeof window !== 'undefined'
  ? window.games
  : typeof process.getGameModel === 'function'
    ? process.getGameModel()
    : null;

function buildGameModel(games) {
  GameModel.LIST = [];
  GameModel.ID_TO_DATA = {};
  GameModel.ROUTE_TO_DATA = {};
  GameModel.LIST_ACTIVE = [];
  GameModel.LIST_ADMIN_BLOG = [];
  GameModel.LIST_PRO = [];
  GameModel.LIST_MAIN_PAGE = [];
  GameModel.LIST_POPULAR = [];
  GameModel.LIST_WITH_ARTICLES = [];
  GameModel.LIST_WOW_ALL_IDS = [];

  games.forEach((unprocessedGame) => {
    const game = {
      id: unprocessedGame.id,
      title: unprocessedGame.title,
      fullTitle: unprocessedGame.full_title,
      routeNamespace: unprocessedGame.namespace,
      menuTitle: unprocessedGame.menu_title,
      aliases: unprocessedGame.aliases,
      active: unprocessedGame.is_active_on_web,
      platforms: unprocessedGame.platforms
        ?.map((platformId) => PlatformModel.LIST.find((platform) => platform.id === platformId)) || [],
      shouldSkipPostPay: !unprocessedGame.has_postpay,
      // TODO: hasNoDetailImage,
      _hasOldBgColor: unprocessedGame.has_old_bg_color,
      mainScreenPriority: unprocessedGame.main_screen_priority,
      searchPriority: unprocessedGame.search_priority,
      defaultPriority: unprocessedGame.default_priority,
      urlLogoPlain: unprocessedGame.url_logo_plain,
      urlBackground: unprocessedGame.url_logo_background_on_main_screen,
      urlCharacter: unprocessedGame.url_logo_character_on_main_screen,
    };

    // TODO: подумать можно ли тут оставить такой костыль или попросить бэков добавить новое поле в модель
    let namespace;
    switch (game.id) {
      case 5:
        namespace = 'COD_MW';
        break;
      case 6:
        namespace = 'WOW_BC';
        break;
      case 11:
        namespace = 'FF14';
        break;
      case 22:
        namespace = 'RUNESCAPE_OLD_SCHOOL';
        break;
      case 20:
        namespace = 'WOT';
        break;
      case 29:
        namespace = 'TESO';
        break;
      case 31:
        namespace = 'GTA';
        break;
      case 33:
        namespace = 'RAINBOW_SIX_SIEGE';
        break;
      case 60:
        namespace = 'FIFA_24';
        break;
      case 75:
        namespace = 'WOW_DISCOVERY';
        break;
      default:
        namespace = game.routeNamespace.toUpperCase().replace(/-/g, '_');
    }

    GameModel[namespace] = game;
    GameModel.LIST.push(game);
    GameModel.ID_TO_DATA[game.id] = game;
    GameModel.ROUTE_TO_DATA[game.routeNamespace] = game;

    if (game.id in GAMES_AS_TAGS_MAP) {
      game._linkToTagId = GAMES_AS_TAGS_MAP[game.id];
    }

    if (game.active) {
      GameModel.LIST_ACTIVE.push(game);

      if (unprocessedGame.main_screen_priority) {
        GameModel.LIST_MAIN_PAGE.push(game);
      }

      if (unprocessedGame.is_popular) {
        GameModel.LIST_POPULAR.push(game);
      }
    }

    if (unprocessedGame.is_active_for_pro) {
      GameModel.LIST_PRO.push(game);
    }

    if (unprocessedGame.is_blog_enabled) {
      GameModel.LIST_ADMIN_BLOG.push(game);
      GameModel.LIST_WITH_ARTICLES.push(game);
    }
  });

  GameModel.LIST_POPULAR = GameModel.LIST_POPULAR.sort((a, b) => b.searchPriority - a.searchPriority);
  if (GameModel.LIST_POPULAR.length > 5) {
    GameModel.LIST_POPULAR.length = 5;
  }

  GameModel.LIST_OTHER = [...GameModel.LIST_ACTIVE]
    .filter((game) => !GameModel.LIST_POPULAR.includes(game))
    .sort((a, b) => {
      if ((a.menuTitle || a.fullTitle) > (b.menuTitle || b.fullTitle)) {
        return 1;
      }
      return -1;
    });

  GameModel.LIST_MAIN_PAGE = GameModel.LIST_MAIN_PAGE.sort((a, b) => b.mainScreenPriority - a.mainScreenPriority);
  if (GameModel.LIST_MAIN_PAGE.length > 28) {
    GameModel.LIST_MAIN_PAGE.length = 28;
  }

  GameModel.LIST_WOW_ALL_IDS = [
    GameModel.WOW.id,
    GameModel.WOW_WOTLK.id,
    GameModel.WOW_BC.id,
    GameModel.WOW_CLASSIC_ERA.id,
    GameModel.WOW_CLASSIC_HARDCORE.id,
    GameModel.WOW_CATACLYSM.id,
    GameModel.WOW_THE_WAR_WITHIN.id,
    GameModel.WOW_DISCOVERY.id,
  ];

  if (typeof window !== 'undefined') {
    const tempGameNode = document.querySelector('#script-games-temp');

    if (tempGameNode) {
      tempGameNode.remove();
    }
  }
}

GameModel.forceUpdate = () => {
  if (typeof process.getGameModel === 'function') {
    gamesArgument = process.getGameModel();
    buildGameModel(gamesArgument);
  }
};

// eslint-disable-next-line func-names
(function (games) {
  // Так как IIFE вызывается только один раз при первом импорте модуля, то для обновления данных
  // с сервера нужно использовать setInterval, который будет обновлять данные каждую минуту
  setInterval(() => {
    GameModel.forceUpdate();
  }, 60000);

  if (!games) {
    return;
  }

  buildGameModel(games);
  games.forEach((game) => {
    buildSeoModelByGame(game);
  });
}(gamesArgument));

GameModel.getGameLogo = (gameId) => `${GameModel.ID_TO_DATA[gameId]?.urlLogoPlain}.svg` || '';
GameModel.getGameBackground = (gameId) => GameModel.ID_TO_DATA[gameId]?.urlBackground || '';

export default GameModel;
